import {
  ReportingComparisonScopes,
  type AgencyBrandingOption,
  type AgencyBrandingOptionValue, ReportingComparisonScope,
} from 'ag-common-lib/lib/contracts/reporting-api.contracts';
import { AG_APPLICATIONS } from 'ag-common-lib/lib/lists/ag-applications.enum';

export const toAgencyBrandingOptionValue = (value: unknown): AgencyBrandingOptionValue | null => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value !== 'string') {
    return null;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }

  const numericValue = Number(trimmedValue);
  if (!Number.isFinite(numericValue)) {
    return null;
  }

  return numericValue;
};

export const areAgencyBrandingOptionValuesEqual = (
  left: AgencyBrandingOptionValue | null | undefined,
  right: AgencyBrandingOptionValue | null | undefined,
): boolean => {
  if (left === undefined || left === null || right === undefined || right === null) {
    return false;
  }

  return left === right;
};

/** Alliance Group's own theme; the reporting API reads `-1` as "no agency branding". */
export const DEFAULT_AGENCY_BRANDING_OPTION: AgencyBrandingOption = {
  value: -1,
  description: 'Alliance Group Main Theme',
};

/** The options API returns Alliance Group Main Theme as the first item. */
export const getDefaultAgencyBrandingValue = (options: AgencyBrandingOption[]): AgencyBrandingOptionValue | null => {
  if (!options.length) {
    return null;
  }

  return options[0].value;
};

/**
 * Branding is offered on ARM (AG level) and Portal MGA/RMD reports.
 * Portal RMD lists AG, the viewed agent's MGA, and every MGA that agent is RMD for.
 */
export const shouldShowReportBranding = (platform: AG_APPLICATIONS, scope: ReportingComparisonScope): boolean => {
  if (platform !== AG_APPLICATIONS.PORTAL) {
    return true;
  }

  return scope === ReportingComparisonScopes.mga || scope === ReportingComparisonScopes.rmd;
};
